<template>
  <div class="site-header">
    <div class="site-header__top">
      <div class="wrapper">
        <div class="site-header__inner">
          <router-link :to="{ name: 'home' }" class="site-header__logo">
            <span class="logo">
              <img
                src="/assets/img/logo.svg?v=20240109"
                alt="Frankfurter Volksbank"
                width="265"
                height="42"
              />
            </span>
          </router-link>
          <span class="app-title">Depotfinder</span>

          <div class="site-header__meta">
            <UiButton v-if="isHome" variant="cta" :to="{ name: 'depotfinder' }">
              {{ $t("header.btn.start-depotfinder") }}
            </UiButton>

            <UiButton
              v-if="!isHome"
              class="restart-btn"
              theme="secondary"
              variant="outline"
              icon="icon-restart"
              @click.native.prevent="resetDepositFinder"
              :aria-label="$t('header.btn.restart-depotfinder')"
            >
              {{ $t("header.btn.restart-depotfinder") }}
            </UiButton>

            <button
              class="icon-btn help-btn icon-btn--primary"
              @click="showSiteMenu"
              ref="toggleMenuBtn"
              aria-label="Service Links"
            >
              <svg width="32" height="32">
                <use xlink:href="#icon-help" />
              </svg>
            </button>

            <nav
              class="site-menu"
              ref="sitemenu"
              :class="{ 'is-active': isSiteMenuVisible }"
              v-closable="{
                exclude: ['toggleMenuBtn'],
                handler: 'hideSiteMenu'
              }"
            >
              <ul>
                <li v-for="(item, index) in menuItems" :key="index">
                  <a :href="item.link">{{ item.text }}</a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>
    <div class="site-header__bottom wrapper">
      <div class="site-header__inner">
        <div class="back-btn-wrap">
          <BackButton
            v-if="$route.name != 'depotfinder.decision'"
            @click="handleBack('/depotfinder')"
          />
        </div>
        <span class="app-title">Kontofinder</span>
        <button
          v-if="!isHome"
          class="icon-btn icon-btn--primary"
          @click.prevent="resetDepositFinder"
        >
          <svg width="24" height="24">
            <use xlink:href="#icon-restart" />
          </svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import UiButton from "./Ui/Button/index.vue";
import BackButton from "./BackButton.vue";
import { backButtonMixin } from "./../mixins/handleBackButton";
import handleOutSideClick from "./../mixins/handleOutsideClick";

export default {
  mixins: [backButtonMixin],
  directives: {
    handleOutSideClick
  },
  components: {
    BackButton,
    UiButton
  },
  data() {
    return {
      isSiteMenuVisible: false,
      menuItems: this.$t("header.menu")
    };
  },
  computed: {
    isHome() {
      return this.$route.name == "home";
    }
  },
  methods: {
    resetDepositFinder() {
      this.$router.push({ name: "depotfinder" });
      this.$store.dispatch("resetDepositFinderState");
    },
    hideSiteMenu() {
      this.isSiteMenuVisible = false;
    },
    showSiteMenu() {
      this.isSiteMenuVisible = !this.isSiteMenuVisible;
    }
  }
};
</script>
